import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class LocalStorageService {

	constructor() { }

	public getTokenAuth = (): string => localStorage.getItem('auth_token') ?? '';
	public setTokenAuth = (token: string) => localStorage.setItem('auth_token', token);

	public getEnviorment = (): string => localStorage.getItem('environment') ?? '';

	public getUser = (): string => localStorage.getItem('user_auth') ?? '';
	public setUser = (data: string) => localStorage.setItem('user_auth', data);


	public clearAllData() {
		localStorage.removeItem("auth_token");
		localStorage.removeItem("refresh_token");
		localStorage.removeItem("environment");
		localStorage.removeItem("user_auth");
	}

	decodeJWT(token: any) {
		try {
			if (!token || typeof token !== 'string') return null;
			const parts = token.split('.');
			if (parts.length !== 3) return null;
			const payloadBase64 = parts[1];
			const payloadJson = atob(payloadBase64.replace(/-/g, '+').replace(/_/g, '/'));
			return JSON.parse(payloadJson);
		} catch {
			console.error('Failed to decode JWT');
			return null;
		}
	}


}
